const Social = () => {
  const socialIcons = [
    {
      id: 'olmo-homes-social-media-facebook',
      socialMedia: 'facebook',
      iconName: 'fab fa-facebook-f',
      link: 'https://www.facebook.com/share/1Fca7akSoN/?mibextid=wwXIfr'
    },
    {
      id: 'olmo-homes-social-media-instagram',
      socialMedia: 'instagram',
      iconName: 'fab fa-instagram',
      link: 'https://www.instagram.com/olmo.homes?igsh=MTVsbnI4cDJudW01YQ=='
    },
    {
      id: 'olmo-homes-social-media-linkedin',
      socialMedia: 'linkedin',
      iconName: 'fab fa-linkedin-in',
      link: 'https://www.linkedin.com/company/olmohomes/'
    },
  ];

  return (
    <>
      {socialIcons.map((social) => (
        <a className="me-3" href={social.link} key={social.id} target="_blank">
          <i className={social.iconName}></i>
        </a>
      ))}
    </>
  );
};

export default Social;
